export default {"src":"/_next/static/image/public/images/ic_location_blue.cadad7dbbd65e71fd2ca1e3b0bb043af.svg","height":19,"width":15};